/* eslint-disable no-unused-vars */
import { createBrowserHistory } from 'history'
import { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ToastProvider } from 'react-toast-notifications'
import ProtectedRoute from '_components/ProtectedRoute'
import PublicRoute from '_components/PublicRoute'
import useScript from '_hooks/useScript'
import ForgotPasswordPage from '_pages/ForgotPassword'
import MainPage from '_pages/Main'
import Policy from '_pages/Policy'
import ResetPasswordPage from '_pages/ResetPassword'
import SignInPage from '_pages/SignIn'
import SignUpPage from '_pages/SignUp'
import LanndingPage from '_pages/LandingPage'
import { DESKTOP, PHONE } from '_utils/constant'
import { getDeviceUser, setDeviceUser } from '_utils/localData'
import { store } from '_redux/store'
import BeeChat from '_components/BeeChat'

import Welcome from '_pages/Event/components/Welcome'
import ProtectedRoutePayment from '../components/ProtectedRoutePayment'
import { DeviceUserContext } from '../context/DeviceUserContext'
import { FirebaseContext } from '../context/FirebaseContext'
import { firebase } from '../firebase/config'
import AppDesktop from '../pages-desktop'
import ListAllEvent from './ListAllEvent'
import PurchaseDetailShare from './Event/PurchaseDetailShare'
import EventDetailV2Share from './Event/EventDetailV2Share'

const history = createBrowserHistory()

const RedirectGoogleSites = () => {
  useEffect(() => {
    window.location.href = 'https://sites.google.com/co-bee.com/home'
  }, [])

  return null
}

export default function App() {
  const [checkDeviceUser, setCheckDeviceUser] = useState(PHONE)

  const urlParams = new URLSearchParams(window.location.search)
  const hasSharedId = urlParams.get('sharedId') !== null

  useEffect(() => {
    if (hasSharedId) {
      setCheckDeviceUser(PHONE)
      return
    }

    const handleResize = () => {
      if (getDeviceUser() === null) {
        if (window.innerWidth >= 1203) {
          setCheckDeviceUser(DESKTOP)
        } else {
          setCheckDeviceUser(PHONE)
        }
      } else {
        setCheckDeviceUser(getDeviceUser())
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (process.env.REACT_APP_ENVIRONMENT === 'production') useScript()

  return (
    <Provider store={store}>
      <ToastProvider>
        <FirebaseContext.Provider value={{ firebase }}>
          <DeviceUserContext.Provider value={{ checkDeviceUser, setCheckDeviceUser }}>
            <Router history={history}>
              <Switch>
                <Route path='/' exact={true} component={LanndingPage} />
                <Route path='/private/list-event' exact={true} component={ListAllEvent} />
                <PublicRoute path='/sign-in' exact={true} component={SignInPage} />
                <Route path='/sign-up' exact={true} component={SignUpPage} />
                <Route path='/reset-password' exact={true} component={ForgotPasswordPage} />
                <Route path='/reset-password-with-code' component={ResetPasswordPage} />
                <Route path='/info' exact={true} component={RedirectGoogleSites} />
                <Route path='/policy' exact={true} component={Policy} />
                <Route path='/event/detail-shared' exact={true} component={EventDetailV2Share} />
                <Route path='/event/purchase-detail-share' exact={true} component={PurchaseDetailShare} />
                <Route path='/payment-order' exact={true} component={ProtectedRoutePayment} />
                <ProtectedRoute path='/welcome' exact={true} component={Welcome} />
                <ProtectedRoute
                  path='/'
                  component={checkDeviceUser === DESKTOP ? AppDesktop : MainPage}
                />
              </Switch>
            </Router>
            {/* <BeeChat /> */}
          </DeviceUserContext.Provider>
        </FirebaseContext.Provider>
      </ToastProvider>
    </Provider>
  )
}
